<div class="flex flex-col gap-4">
  @if (readOnly() !== true) {
    <form class="flex flex-col gap-4" [formGroup]="form">
      <div class="flex items-center gap-4">
        <mat-form-field class="flex-1">
          <mat-label>Inbound SMS Cost</mat-label>
          <mat-select formControlName="inboundPriceId">
            @for (
              inboundPrice of inboundPrices();
              track inboundPrice.priceLookupId
            ) {
              <mat-option [value]="inboundPrice.priceLookupId">
                {{ inboundPrice.pricingDescription }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex-1">
          <mat-label>Outbound SMS Cost</mat-label>
          <mat-select formControlName="outboundPriceId">
            @for (
              outboundPrice of outboundPrices();
              track outboundPrice.priceLookupId
            ) {
              <mat-option [value]="outboundPrice.priceLookupId">
                {{ outboundPrice.pricingDescription }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex-1">
          <mat-label>Marketing SMS Cost</mat-label>
          <mat-select formControlName="marketingPriceId">
            @for (
              marketingPrice of marketingPrices();
              track marketingPrice.priceLookupId
            ) {
              <mat-option [value]="marketingPrice.priceLookupId">
                {{ marketingPrice.pricingDescription }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  } @else {
    @if (priceSummary(); as priceSummary) {
      <h3 class="mat-subtitle-1 !mb-0">Pricing</h3>

      <div class="flex flex-col gap-4">
        <span
          >SMS is charged per segment.
          <a
            href="https://www.twilio.com/blog/2017/03/what-the-heck-is-a-segment.html"
            target="_blank"
            >Read More</a
          ></span
        >

        <div>
          <strong>Inbound SMS Cost: </strong>
          <span>{{ priceSummary.inbound?.pricingDescription }}</span>
        </div>

        <div>
          <strong>Outbound SMS Cost: </strong>
          <span>{{ priceSummary.outbound?.pricingDescription }}</span>
        </div>

        <div>
          <strong>Marketing SMS Cost: </strong>
          <span>{{ priceSummary.marketing?.pricingDescription }}</span>
        </div>
      </div>
    }
  }
</div>
